import * as React from 'react';
import { H3 } from '@liveauctioneers/caterwaul-components/lib/Text/Text';
import styled from 'styled-components';

type AttachFilesPlaceholderProps = {
    readonly testid?: string;
};
const AttachFilesPlaceholder = ({ testid = 'messengerAttachFilesPlaceholder' }: AttachFilesPlaceholderProps) => (
    <>
        <Container data-testid={testid}>
            <H3 as="h3">Drag and drop up to 5 images here</H3>
        </Container>
        <MobileSpacer />
    </>
);

export default AttachFilesPlaceholder;

const MobileSpacer = styled.div`
    @media (max-width: ${({ theme }) => theme.breakpoints.mobileWidth}) {
        height: 9px;
    }
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    background-color: ${({ theme }) => theme.colors.grey500};
    border: dashed 2px ${({ theme }) => theme.colors.grey300};
    margin: 9px 18px 17px;
    padding: 23px 18px;
    text-align: center;
    h3 {
        color: ${({ theme }) => theme.colors.steel};
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.mobileWidth}) {
        display: none;
    }
`;
